import React from 'react';
// import './index.scss';

const SVGPureIcon = ({
  name,
  className,
  iconClass,
  color,
  onClick,
  id = '',
  prefix = 'icon',
  size = 0,
  width = '100%',
  height = '100%',
  scale = 1, // 在 svg 上运用 transform 会让 svg 模糊
  style = {},
  iconStyle = {},
}) => {
  const option = {};
  id && (option.id = id);
  onClick && (option.onClick = onClick);

  const iconOption = {};
  color && (iconOption.color = color);

  const scaleStyle =
    scale != 1
      ? { transform: `scale(${scale})`, transformOrigin: `center center` }
      : {};

  return (
    <svg
      aria-hidden
      className={className}
      style={{ ...style }}
      width={size || width}
      height={size || height}
      {...option}
    >
      <use
        className={['svg-icon', iconClass]}
        href={`#${prefix}-${name}`}
        style={{ ...scaleStyle, ...iconStyle, ...iconOption }}
      />
    </svg>
  );
};

export default SVGPureIcon;
